/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_StaleInputs */

const vi_einvoice_stale = /** @type {(inputs: Einvoice_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qua ngày, chưa phát hành`)
};

/**

* @param {Einvoice_StaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_stale = /** @type {((inputs?: Einvoice_StaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_StaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_stale(inputs)
});